import { drawerRef, drawerState } from 'src/stores/ui/sidepanel-public';
import { showNewLayout } from 'src/stores/toDelete/new_layout';
import { sidePanelState, type SidePanelStateType } from 'src/stores/ui/sidepanel-public';
import { get } from 'svelte/store';

export const setSidePanelState = (state: SidePanelStateType) => {
	const isNewLayout = get(showNewLayout);
	if (isNewLayout) {
		sidePanelState.update((prev) => {
			return {
				...prev,
				...state,
			};
		});
	} else {
		let drawer = get(drawerRef);
		if (state.open !== undefined && drawer) {
			state.open ? drawer.open() : drawer.close();
		}

		drawerState.update((prev) => ({
			...prev,
			...state,
		}));
	}
};

export const checkIsComponent = (data: any) => {
	return typeof data === 'function' ? data : null;
};

/**
 * Workaround for the design-system `Drawer` / `Sidepanel`: both attach a
 * `touchend` listener on the document inside their `onTouch` handlers but
 * never listen for `touchcancel`. On Android with gesture navigation, the
 * system back-swipe begins as a normal touch sequence (so the DS sets its
 * internal `isTouched=true`) and is then cancelled by the OS to consume the
 * gesture. Because `touchend` never arrives, `isTouched` stays true and the
 * overlay (`show: isOpen || isTouched`) remains visible after the panel
 * closes — until the user taps the screen, which finally fires `touchend`
 * and resets the state (FE-1630).
 */
export const bridgeTouchCancelToTouchEnd = (): (() => void) => {
	const handler = (event: TouchEvent) => {
		const target = (event.target as EventTarget) ?? document;
		target.dispatchEvent(new Event('touchend', { bubbles: true, cancelable: true }));
	};

	document.addEventListener('touchcancel', handler, { passive: true });

	return () => document.removeEventListener('touchcancel', handler);
};
